import * as React from 'react';
import { Button, TextField } from '@mui/material';
import { useTranslation } from "react-i18next";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import moment from 'moment';
import { getLocale } from '../utils/localeUtils';

interface Props {
    date: Date;
    onDateUpdate: (date: any) => void;
    fullWidth?: boolean;
    disabled?: boolean;
}

const WeekSwitcher = (props: Props) => {
    const { t } = useTranslation();
    const disabled = props.disabled ?? false;
    const [date, setDate] = React.useState(moment(props.date).startOf("week").toDate());

    React.useEffect(() => {
        setDate(moment(props.date).startOf("week").toDate());
    }, [props.date])

    const handleDateChange = (date: Date | null) => {
        if (!disabled) {
            props.onDateUpdate(date);
        }
    }

    const handleLeft = () => {
        if (!disabled) {
            const newDate = moment(date).subtract(1, "week").toDate();
            setDate(newDate);
            props.onDateUpdate(newDate);
        }
    }

    const handleRight = () => {
        if (!disabled) {
            const newDate = moment(date).add(1, "week");
            setDate(newDate.toDate());
            props.onDateUpdate(newDate.toDate());
        }
    }

    const containerStyle: React.CSSProperties = props.fullWidth
        ? { display: "flex", alignItems: "center", width: "100%", justifyContent: "space-between", gap: 8 }
        : { display: "flex", alignItems: "center" };
    const buttonStyle = props.fullWidth ? { flexShrink: 0 } : undefined;

    return (
        <div style={containerStyle}>
            <Button onClick={handleLeft} style={buttonStyle} disabled={disabled}>{"<"}</Button>
            <LocalizationProvider dateAdapter={AdapterDateFns} locale={getLocale()}>
                <DatePicker
                    label={t("date")}
                    value={date}
                    disableMaskedInput
                    disabled={disabled}
                    onChange={handleDateChange}
                    renderInput={(params) => <TextField {...params} margin="normal" name="date" fullWidth={props.fullWidth} />}
                />
            </LocalizationProvider>
            <Button onClick={handleRight} style={buttonStyle} disabled={disabled}>{">"}</Button>
        </div>
    )
};

export default WeekSwitcher;
